
const TopBar = () => {
  return (
    <div className="z-[9999999999999999999999999999999999999] fixed top-0 left-0 right-0 w-full h-16 bg-[#7c3aed] text-white flex items-center justify-center">
        <span className="text-base font-medium">DISCLAIMER: You are using the BETA version of this website</span>
    </div>
  )
}

export default TopBar